import React from "react";
import styles from "./bank-deposit-filter.module.scss";
import { Autocomplete, Field, Filter, DateRange, Button } from "components/commons";
import { locale } from "localization/en";
import { SearchField } from "components/commons";
import { useRouter } from "hooks";
import { Path } from "enums";

const BankDepositFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const router = useRouter();
  const depositType = [
    { label: locale.fuelAndLubesSales, value: locale.fuelAndLubesSales },
    { label: locale.lpgSales, value: locale.lpgSales },
    { label: locale.lubeserv, value: locale.lubeserv },
    { label: locale.keyAccountPayments, value: locale.keyAccountPayments },
    { label: locale.revolvingFund, value: locale.revolvingFund },
    { label: locale.consumableFund, value: locale.consumableFund },
    { label: locale.specialRequest, value: locale.specialRequest },
    { label: locale.customerRefundableDeposit, value: locale.customerRefundableDeposit },
  ];
  const dateType = [
    { label: locale.shiftDate, value: "shift" },
    { label: locale.depositDate, value: "deposit" },
  ];
  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          close={resetFilter}
          clear={applyClearFilter}
          submit={() => {
            applyFilter();
          }}
          filterCount={filterCount}
        >
          <Field
            label={locale.filterDateBy}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="dateType"
              value={filterState.dateType}
              options={dateType}
              onChange={(name, { value }) => {
                modifyFilter({ [name]: value });
              }}
            />
          </Field>
          <Field
            className={styles.date}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.date}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({ startDate, endDate });
              }}
            />
          </Field>
          <Field
            label={locale.depositType}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="type"
              value={filterState.type.value}
              options={depositType}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({
                  [name]: {
                    value,
                    isSelectedAll,
                  },
                });
              }}
              multiple
              hasAll
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchField
            placeholder={[locale.depositID].join(", ")}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
          />
        </Field>
      </div>
      <Button
        onClick={() => router.push(Path.AddBankDeposit)}
        primary
        className={styles.palePurpleButton}
      >
        {locale.addBankDeposit}
      </Button>
    </div>
  );
};

export default BankDepositFilter;
